import anime from 'animejs';
import Lightbox from '@novembrecom/nlightbox';

class LightboxVimeo {
    constructor(lightbox, key, dataset) {
        this.lightbox = lightbox;
        this.key = key;

        this.loaded = false;
        this.loading = false;
        this.failed = false;
        this.data = null;
        this.dataset = dataset;
    }

    /**
     * This function should return the content of your element
     * @return {Element}
     */
    // eslint-disable-next-line class-methods-use-this
    load() {
        // const part = document.createElement('p');
        const vimeo = 'https://player.vimeo.com/video/';

        const tab = this.dataset.src.split('/');
        const id = tab[3];
        const link = `${vimeo}${id}?title=false&byline=false&portrait=false&playsinline=false&autoplay=1`;

        const iframe = document.createElement('iframe');
        const container = document.createElement('div');
        container.setAttribute('class', 'lightbox__video_container');
        iframe.setAttribute('src', link);
        iframe.setAttribute('class', 'vimeo');
        iframe.setAttribute('allow', 'autoplay');
        container.appendChild(iframe);
        // iframe.setAttribute('controls', 'true');
        return container;
    }
}

LightboxVimeo.TYPE_NAME = 'vimeo';

const lightbox = new Lightbox({
    uid: 'lightbox-1',
    enableNavUI: true,
    enablePaginationUI: true,
    enableBulletlistUI: true,
    enableCloseOnBlur: true,
    animations: {
        showElement: node => anime({
            targets: node,
            opacity: 1,
            duration: 300,
            delay: 100,
            easing: 'easeOutSine',
        }),
    },
});


// you can register multiple classes
lightbox.init([LightboxVimeo]);


const lightboxTestimony = new Lightbox({
    uid: 'lightbox-testimony',
    enableNavUI: false,
    enablePaginationUI: false,
    enableBulletlistUI: false,
    enableCloseOnBlur: true,
    animations: {
        showElement: node => anime({
            targets: node,
            opacity: 1,
            duration: 300,
            delay: 100,
            easing: 'easeOutSine',
        }),
    },
});

lightboxTestimony.init([LightboxVimeo]);

const lightboxVideo = new Lightbox({
    uid: 'lightbox-video',
    enableNavUI: false,
    enablePaginationUI: false,
    enableBulletlistUI: false,
    enableCloseOnBlur: true,
    animations: {
        showElement: node => anime({
            targets: node,
            opacity: 1,
            duration: 300,
            delay: 100,
            easing: 'easeOutSine',
        }),
    },
});

lightboxVideo.init([LightboxVimeo]);
